import { render } from "./indexsixblog.vue?vue&type=template&id=61f762ea"
import script from "./indexsixblog.vue?vue&type=script&lang=js"
export * from "./indexsixblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__